import { useAsyncEffect } from '@/hooks';
import { useStores } from '@/store';
import { clipboardIconOnClick } from '@/util';
import { startCase } from 'lodash';
import { observer } from 'mobx-react';
import React from 'react';
import { Form, Icon, Input, Table } from 'semantic-ui-react';
import style from './onboarding-submission-details.less';

export const OnboardingSubmissionDetailsPayrollInfo = observer(() => {
  const { payrollStore } = useStores();

  useAsyncEffect(async () => {
    await payrollStore.fetchAll();
  }, []);

  return (
    <>
      <Form className={style.form_container} style={{ width: '100%' }}>
        <fieldset style={{ paddingTop: 14, paddingBottom: 14 }}>
          <legend>EARNINGS</legend>

          <Input
            type="search"
            placeholder="Search..."
            onChange={({ target: { value } }) => {
              payrollStore.items.setFilter(value);
            }}
            style={{ marginBottom: 16, minWidth: '300px' }}
          />

          <div style={{ maxHeight: 500, overflowY: 'auto' }}>
            <Table celled striped compact size="small" style={{ boxShadow: 'none' }}>
              <Table.Header>
                <Table.Row>
                  <Table.HeaderCell>Item Name</Table.HeaderCell>
                  <Table.HeaderCell>Wage Type</Table.HeaderCell>
                </Table.Row>
              </Table.Header>

              <Table.Body>
                {payrollStore.items.filtered.map(({ description, wageType }) => {
                  return (
                    <Table.Row>
                      <Table.Cell>
                        {description}{' '}
                        <Icon
                          name="clipboard"
                          style={{ float: 'right', cursor: 'pointer', color: '#666' }}
                          onClick={() => clipboardIconOnClick(description, 'Item Name')}
                        />
                      </Table.Cell>
                      <Table.Cell>{startCase(wageType)}</Table.Cell>
                    </Table.Row>
                  );
                })}
              </Table.Body>
            </Table>
          </div>
        </fieldset>
      </Form>
    </>
  );
});
